import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonTableComponent } from '@lib-ui/common-table/ui/common-table.component';
import { LoaderComponent } from '@lib-ui/loader/loader.component';
import { ICommonTableAction, ICommonTableConfig } from '@lib-ui/common-table/models/common-table.interface';
import { CommonTableConfig } from '@lib-ui/common-table/models/common-table-config.class';
import { MatDialog } from '@angular/material/dialog';
import { RowAction } from '@lib-ui/common-table/models/common-table.enum';
import { CustomFieldsTableService } from './custom-fields-table.service';
import { CustomFieldsFormComponent } from '@lib-ui/forms/custom-fields-form/custom-fields-form.component';

@Component({
    selector: 'app-custom-fields-config',
    standalone: true,
    imports: [CommonModule, CommonTableComponent, LoaderComponent],
    templateUrl: './custom-fields-config.component.html',
    styleUrl: './custom-fields-config.component.scss'
})
export class CustomFieldsConfigComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН'},
            { name: 'label', title: 'Название' },
            { name: 'type', title: 'Тип' },
            { name: 'projectName', title: 'Проект' },
            { name: 'status', title: 'Статус' },
            { name: 'required', title: 'Обязательное поле' },
        ],
        createButtonLabel: 'Добавить настраиваемое поле',
        showCreateButton: true,
    });

    constructor(
        protected customFieldsTableService: CustomFieldsTableService,
        private dialog: MatDialog

    ) { }

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ customFieldsConfigId: Number(value.data[0]['id']) });
        } else if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
    }

    openDialog(data: { customFieldsConfigId?: number }): void  {
        this.dialog.open(CustomFieldsFormComponent, {
            width: '50%',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.customFieldsTableService.updateData(this.tableConfig);
            }
        });
    };
}
